<template>
  <div class="p-3 pt-5 mt-5 p-component flex justify-content-between app-footer">
    <div class="px-2 text-sx font-bold">
      POD Admin Web Application 2021 HTCPL&copy;
    </div>
    <div class="px-2">
      <img
        src="https://www.haadthip.com/assets/images/logo.svg"
        style="width: 120px"
        alt=""
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppFooter",
});
</script>

<style scoped>
.app-footer {
  border: 1px solid lightgrey;
}
</style>
